import { configureStore } from "@reduxjs/toolkit";
import selectedNewsletterReducer from "./newsletterSlice.jsx";

const store = configureStore({
  reducer: {
    selectedNewsletter: selectedNewsletterReducer,
  },
});

export default store;
